import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MoveToInbox from '../../components/modal/MoveToInbox';
import { getInboxIngestionTargets, moveRecordToInbox } from '../../actions/records';

export default withRouter(connect(null, {
  getInboxIngestionTargets,
  moveRecordToInbox,
})(MoveToInbox));
